import type { components } from '@/api'
import { get } from './client'

export type ListApiKeysPath = '/api/api_keys'
export type ListApiKeysResponse = components['schemas']['ApiKeys.ListApiKeysResponse']
export type ListApiKeysRequest = undefined

export const listApiKeys = () =>
  get<ListApiKeysRequest, ListApiKeysResponse, ListApiKeysPath>(`/api/api_keys`, undefined)
